import React from 'react';

import { useApp } from '../store/AppContext';
import TimelineHeader from './timeline/header/TimelineHeader';
import { buildMemberRows } from './timeline/memberRows';
import { buildProjectRows } from './timeline/projectRows';
import ScrollbarStyle from './timeline/ScrollbarStyle';
import { monthGroups, periodLabel, weekGroups } from './timeline/shared/calendar';
import { nameColumnWidth } from './timeline/shared/style';
import TimelineToolbar from './timeline/TimelineToolbar';
import TimelineTooltip from './timeline/TimelineTooltip';

const NO_ROWS = { names: [], bodies: [], rowsTotalH: 0 };

/* Timeline : planning des affectations, par membre ou par projet.

   Lignes : deux tableaux parallèles [noms] et [corps], rendus dans deux panneaux séparés au lieu
   d'une seule grille avec colonne "sticky" (cf. useTimelineScroll). Chaque ligne est posée en
   position absolue au même « top » des deux côtés (cf. positionRows) : les deux mises en page
   arrondissent les sous-pixels différemment, un calcul explicite évite toute dérive. */
export default function TimelinePage() {
  const app = useApp();
  const { COL, days, timelineBodyScrollRef, timelineGroupBy, timelineScrollRef } = app;
  const N = days.length;
  const { names, bodies, rowsTotalH } =
    timelineGroupBy === 'dev'
      ? buildMemberRows(app)
      : timelineGroupBy === 'proj'
        ? buildProjectRows(app)
        : NO_ROWS;

  return (
    <div className="[flex:1] flex flex-col overflow-hidden min-h-[0]">
      <TimelineToolbar periodLabel={periodLabel(days)} />
      <div className="[flex:1] flex flex-col overflow-hidden min-h-[0]">
        <TimelineHeader monthGroups={monthGroups(days)} weekGroups={weekGroups(days)} />
        {/* Corps : un seul scroll vertical partagé entre la colonne de noms et la grille des jours */}
        <div
          ref={timelineScrollRef}
          className="tl-vscroll [flex:1] overflow-y-auto overflow-x-hidden min-h-[0] [scrollbar-width:thin] [scrollbar-color:#DCE5E7_transparent]"
        >
          <div className="flex">
            <div
              className="shrink-0 relative"
              style={{ width: nameColumnWidth(timelineGroupBy), height: rowsTotalH }}
            >
              {names}
            </div>
            <div
              ref={timelineBodyScrollRef}
              className="tl-hscroll [flex:1] overflow-x-auto overflow-y-hidden [scrollbar-width:thin] [scrollbar-color:#DCE5E7_transparent]"
            >
              <div className="relative" style={{ width: N * COL, height: rowsTotalH }}>
                {bodies}
              </div>
            </div>
          </div>
        </div>
      </div>
      <ScrollbarStyle />
      <TimelineTooltip />
    </div>
  );
}
